import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import {
  KVPlaneIntersection,
  KVPlaneIntersectionJSON,
  RolodexEntryPatchJson,
} from 'types'

import { KVMessageDef } from './index'

export function getNewPlaneIntersectionMessage() {
  return {
    type: 'planeIntersection',
    requiredData: ['planeIntersectionId'],

    callback: (
      json: KVPlaneIntersectionJSON,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      const planeIntersection = KVPlaneIntersection.fromJSON(json)
      const newKVPlaneIntersections = [
        ...(kv.planeIntersections ?? []),
        planeIntersection,
      ]
      kv.setPlaneIntersections(newKVPlaneIntersections)

      // Send to Rolodex
      const patchData: RolodexEntryPatchJson = {
        id: kv.kestrelModel?.id ?? '',
        data: {
          planeIntersections:
            newKVPlaneIntersections?.map((m) =>
              KVPlaneIntersection.toJSON(m)
            ) ?? [],
        },
      }
      kv.rolodexPatch([patchData])
    },
  } as KVMessageDef
}
